import { action } from 'typesafe-actions';
import { CriacaoAssuntoTypes } from './types';

export const getAssuntosRequest = (company: any) =>
  action(CriacaoAssuntoTypes.GET_ASSUNTOS_RESQUEST, {});

export const getAssuntosSuccess = (data: any) =>
  action(CriacaoAssuntoTypes.GET_ASSUNTOS_SUCCESS, { data });

export const getAssuntosFailure = () =>
  action(CriacaoAssuntoTypes.GET_ASSUNTOS_FAILURE, {});

export const getAssuntosHandleChangePageRequest = (
  newPage: number,
  rowsPerPage: number,
  company: number,
) =>
  action(CriacaoAssuntoTypes.GET_ASSUNTOS_HANDLE_CHANGE_PAGE_RESQUEST, {
    newPage,
    rowsPerPage,
    company,
  });

export const getAssuntosHandleChangePageSuccess = (data: any) =>
  action(CriacaoAssuntoTypes.GET_ASSUNTOS_HANDLE_CHANGE_PAGE_SUCCESS, {
    data,
  });

export const getAssuntosHandleChangePageFailure = () =>
  action(CriacaoAssuntoTypes.GET_ASSUNTOS_HANDLE_CHANGE_PAGE_FAILURE, {});

export const changeStateAssuntosRequest = (
  contact_subject_id: string,
  country_company_id: string,
  operator_id: string,
  status_fl: string,
  subject_ds: string,
  total_itens: string,
) =>
  action(CriacaoAssuntoTypes.CHANGE_STATE_ASSUNTOS_RESQUEST, {
    contact_subject_id,
    country_company_id,
    operator_id,
    status_fl,
    subject_ds,
    total_itens,
  });

export const changeStateAssuntosSuccess = (data: any) =>
  action(CriacaoAssuntoTypes.CHANGE_STATE_ASSUNTOS_SUCCESS, {
    data,
  });

export const changeStateAssuntosFailure = () =>
  action(CriacaoAssuntoTypes.CHANGE_STATE_ASSUNTOS_FAILURE, {});

export const updateAssuntosRequest = (company: any, recaptcha: string) =>
  action(CriacaoAssuntoTypes.UPDATE_ASSUNTOS_RESQUEST, { company, recaptcha });

export const updateAssuntosSuccess = () =>
  action(CriacaoAssuntoTypes.UPDATE_ASSUNTOS_SUCCESS, {});

export const updateAssuntosFailure = () =>
  action(CriacaoAssuntoTypes.UPDATE_ASSUNTOS_FAILURE, {});

interface PostAssunto {
  country_company_id: any;
  subject_ds: string;
}
export const postAssuntosRequest = (params: PostAssunto) =>
  action(CriacaoAssuntoTypes.POST_ASSUNTOS_RESQUEST, { params });

export const postAssuntosSuccess = () =>
  action(CriacaoAssuntoTypes.POST_ASSUNTOS_SUCCESS, {});

export const postAssuntosFailure = () =>
  action(CriacaoAssuntoTypes.POST_ASSUNTOS_FAILURE, {});
